import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {SearchResult} from '../_models/SearchResult';
import {CqSchede} from '../_models/CqSchede';
import {BehaviorSubject, firstValueFrom} from 'rxjs';
import {HubConnection} from '@microsoft/signalr';
import {OrganizzazioniService} from './organizzazioni.service';
import {SaveMessage} from '../_helpers/save-message';
import {buildHubConnection, startHubConnection, stopHubConnection} from '../_helpers/hub-connection.helper';
import {HubState} from '../_models/hub-state';

@Injectable({providedIn: 'root'})
export class QualitaSchedeService {
  public lastSchedaCreated: BehaviorSubject<CqSchede> = new BehaviorSubject<CqSchede>(null);
  public lastSchedaUpdated: BehaviorSubject<CqSchede> = new BehaviorSubject<CqSchede>(null);
  public lastSchedeDeleted: BehaviorSubject<CqSchede> = new BehaviorSubject<CqSchede>(null);
  public hubState: BehaviorSubject<number> = new BehaviorSubject<number>(HubState.Connecting);
  private hubConnection: HubConnection;

  constructor(
    private http: HttpClient,
    private organizzazioniService: OrganizzazioniService,
    private saveMessage: SaveMessage) {}

  public startConnection() {
    this.hubConnection = buildHubConnection(`${environment.localApiUrl}hubs/cqschede`, this.hubState);

    this.hubConnection.on('SendCreated', (scheda: CqSchede) => {
      if (scheda.organizzazioneId === this.organizzazioniService.organizzazioneId) {
        this.saveMessage.messageInfo('Nuova scheda CQ creata.');
        this.lastSchedaCreated.next(scheda);
      }
    });

    this.hubConnection.on('SendUpdated', (scheda: CqSchede) => {
      if (scheda.organizzazioneId === this.organizzazioniService.organizzazioneId) {
        this.saveMessage.messageInfo('Scheda CQ aggiornata.');
        this.lastSchedaUpdated.next(scheda);
      }
    });

    this.hubConnection.on('SendDeleted', (scheda: CqSchede) => {
      if (scheda.organizzazioneId === this.organizzazioniService.organizzazioneId) {
        this.saveMessage.messageInfo('Scheda CQ eliminata.');
        this.lastSchedeDeleted.next(scheda);
      }
    });

    return startHubConnection(this.hubConnection, this.hubState);
  }

  public stopConnection() {
    void stopHubConnection(this.hubConnection);
  }

  async getSchedeOfOdP(orgId: number, rifOdP: string, numFase: number, codBox: string) {
    return firstValueFrom(
      this.http.post<SearchResult<CqSchede>>(`${environment.localApiUrl}api/Qualita/SchedeByRifOdP/${orgId}`,
        {page: 0, count: 0, search: rifOdP, numFase, codBox, sortField: 'IdSchedaControllo', sortAsc: true})
    );
  }

  async createSchedaAsync(cqScheda: CqSchede) {
    return firstValueFrom(this.http.post<CqSchede>(`${environment.localApiUrl}api/Qualita/CreateSchedaQualita`, cqScheda));
  }

  getIdOrdine(rifOrdine: string) {
    if (rifOrdine.length < 13) {
      return {idDocumento: 0, idRiga: 0};
    }
    return {idDocumento: parseInt(rifOrdine.substring(0, 9), 10), idRiga: parseInt(rifOrdine.substring(9, 13), 10)};
  }
}
